<div class="top-bar-container">
	@if (topBarTemplate) {
		<ng-container [ngTemplateOutlet]="topBarTemplate"></ng-container>
	} @else {
		@if (icon()) {
			<app-icon [name]="icon()!" class="icon" color="primary-1" (click)="iconClick.emit($event)"></app-icon>
		}
		<h3 class="label">{{ sidebarTitle() }}</h3>
		<app-icon name="sluiten" class="close-button" color="primary-1" hoverColor="secondary-1" (click)="close.emit($event)"></app-icon>
	}
</div>
<div class="content-container" [class.no-padding]="noPadding()">
	<ng-content></ng-content>
</div>
@if (bottomBarTemplate) {
	<div class="bottom-bar-container">
		<ng-container [ngTemplateOutlet]="bottomBarTemplate"></ng-container>
	</div>
}
